import history from '../history';
import {
    queryConfiguration,
    queryAccountByEffectiveDate,
} from '../api/selectiongql';
import {
    CONFIG_LOAD,
} from './types';
import DATETIME_UTILITY from '../utils/datetime';

export const handleGetConfiguration = ({token, pageType}, callback) => async (dispatch, getState) => {
    const data = await queryConfiguration({token});
    // console.log('data->', data);
    if (data instanceof Error) {
        if (callback) callback(data);
    } else {

        // Load Account Data Based on Selection Start Date
        // console.log('-->', data.selection.startDate);
        let selectionStartDate = DATETIME_UTILITY.getCurrentDateTime().format("DD/MM/YYYY");
        if (data.selection && data.selection.startDate) {
            selectionStartDate = DATETIME_UTILITY.parseDateTimeFromUTC(data.selection.startDate);
            // console.log('-->', selectionStartDate);
            selectionStartDate = selectionStartDate.format("DD/MM/YYYY");
            // console.log('-->', selectionStartDate);
        }

        const _account = await queryAccountByEffectiveDate({
            token,
            effectiveDate: selectionStartDate,
        });
        // console.log('_account->', _account);

        if (_account instanceof Error) {
            if (callback) callback(_account);
        } else {
            data.account = _account;
            dispatch({
                type: CONFIG_LOAD,
                payload: data,
            });
            if (pageType === 'selection') {
                history.replace('/home');
            } else if (pageType === 'history') {
                history.replace('/history');
            }
        }
        
    }
};
